/* global mod_tickets, twemoji, emoji */

$(function(){
    // mod_tickets.$emoji_last = $('.emoji_last');
    // $(document).on('click', '#emoji_select img.emoji, .emoji_last img.emoji', function(){
    // 	var symbol = $(this).attr('alt');
    // 	var emoji_html = mod_tickets.prepare_to_edit(symbol);
    //
    // 	$(this).closest('.add_form').find('.textarea').focus();
    //
    // 	document.execCommand('insertHtml', false, emoji_html);
    //
    // 	emoji.set_last(symbol);
    // 	if(!$(this).closest('.emoji_last').length) mod_tickets.$emoji_last.html(emoji.get_last());
    // });
    //
    // mod_tickets.$emoji_last.html(emoji.get_last());
});

//mod_tickets.youtube_render = function(html){
//	var youtube = '<iframe width="98%" height="320" src="https://www.youtube.com/embed/$1?autoplay=0"></iframe><br>&nbsp;';
//	html = html.replace(/https?:\/\/www.youtube.com\/embed\/(\w+)(?:\?[^\s]*)?/g, youtube);
//	html = html.replace(/https?:\/\/www.youtube.com\/v\/(\w+)(?:\?[^\s]*)?/g, youtube);
//	html = html.replace(/https:\/\/youtu.be\/(\w+)(?:\?[^\s]*)?/g, youtube);
//	html = html.replace(/https?:\/\/www.youtube.com\/watch\?v=(\w+)(?:&[^\s]*)?/g, youtube);
//	return html;
//};

mod_tickets.youtube_unrender = function(html){
    html = html.replace(/<iframe[^>]*src="([^"]+)"><\/iframe>/g, '$1');
    return html;
};

// отформатировать поле ввода
mod_tickets.prepare_to_edit = function(html){
    // html = html.replace(/<img class="emoji"[^>]*alt="([^"]*)"[^>]*>/g, '$1');
    html = html.replace(/<img src="([^"]*)"[^>]*>/g, '$1');

    html = html.replace(/<br[^>]*>/g, ',¤,');
    html = html.replace(/<div[^>]*>/g, ',¤¤,');
    html = html.replace(/<\/div>/g, ',¤¤¤,');
    html = html.replace(/(<\w+)(\s[^>]*)(>)/g, '$1$3'); // удалить атрибуты
    html = html.replace(/<[^>]+>/g, ''); // удалить все тэги
    html = html.replace(/\(¤¤¤¤,([^¤]+),¤¤¤¤\)/g, '<$1>'); // восстанвоить img
    html = html.replace(/,¤¤¤,/g, '</div>'); // восстанвоить div
    html = html.replace(/,¤¤,/g, '<div>'); // восстанвоить div
    html = html.replace(/,¤,/g, '<br>'); // восстанвоить br

    html = html.replace('&amp;#', '&#');
    // html = emoji.render(html);
//	html = mod_tickets.youtube_render(html);
    html = html.replace(/<\s*/g, '<').replace(/>\s*/g, '>');

    html = html.trim().replace(/\r\n|\r|\n/g, '<br>'); // символ Enter

    return html;
};

// подготовить поле к сохранению в БД
mod_tickets.prepare_to_save = function(html){
    html = html.replace(/\r|\n/g, '');

//	// перевести youtube на ссылку
//	html = mod_tickets.youtube_unrender(html);

    // перевести изображения смайликов в символы
    // html = emoji.unrender(html);

    var $html = $('<div>').append(html);
    $.map($('br, > p, > div', $html), function(el){
        $(el).before('\n');
    });
    $.map($('* p:not(:first-child), * div:not(:first-child)', $html), function(el){
        $(el).before('\n');
    });

    var text = $html.text().trim();
    text = text.replace(/\n\s*\n\s*\n/g, '\n\n');
    text = text.replace(/&nbsp;/g, ' ');

    return text;
};